import Title from "../Title/Title";
import { connect } from "redux";
import { Slider, Box } from "@material-ui/core";
import Concept from "../Concept/Concept";
import DropdownLocations from "../Select/DropdownLocations";
import DropdownSector from "../Select/DropdownSector";
import Legend from "../Legend/Legend";
// import Main from "../Main/Main";
import Cards from "../Cards/Cards";
import React, { useState } from "react";
import MainMapLibre from '../Main/MainMapLibre';

const Bogota = () => {
    const
        [ selection, setSelection ] = useState('locations'),
        [sliderValue, setSliderValue] = useState(1800),
        onClick = evt => {
            setSelection(evt.target?.innerText?.toLowerCase());
        },
        handleChange = (evt, newValue) => {
            console.log(newValue)
            setSliderValue(newValue)
        }
    return (
        <div className='main-page'>
            <Title h1='Accomodation and Amenities Map of Bogota'></Title>
            <Concept onClick={ onClick } selection={ selection }>
                {
                   // ['locations', 'neighborhood'].map(o =>  {
                    ['locations'].map(o =>  {

                    const [a, ...rest] = o
                    return <div className={ ['div-buttons', selection == o ? 'selected' : '' ].join(' ') }
                                                  onClick={evt => onClick(evt) }
                    >
                        <button className={ ['buttons', selection == o ? 'selected' : '', 'button-loc'].join(' ') }>
                            {
                                `${ a.toUpperCase() + rest .join('')}`
                            }
                        </button>
                    </div> })
                }
            </Concept>
            { selection === 'locations' && <DropdownLocations/> }
            { selection === 'neighborhood' && <DropdownSector/> }
            <div style={{ gridColumn: '8 / 10', gridRow: '2 / 3' }}>
                <p> Price Range:</p>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'center', // Horizontal centering
                    alignItems: 'center',     // Vertical centering
                    width: '100%',            // Ensure the container spans the full width
                    height: '20px'           // Give it some height if needed
                }}>
                    <span style={{ paddingRight: '10px' }}> $500 </span>
                    <Slider
                        aria-label="Volume"
                        defaultValue={1800}
                        step={10}
                        min={ 500 }
                        max={3000 }
                        onChange={ handleChange }
                    />
                    <span style={{ paddingLeft: '10px' }}> $1,800 </span>
                </Box>
            </div>
            {/*<Legend/>*/}
            {/*<Main id='city-container'/>*/}
            <MainMapLibre id='city-container' sliderValue={ sliderValue }/>
            <Cards sliderValue={ sliderValue }/>
        </div>
    )
}

const mapStateToProps = () => (
    dispatch => ({

    })
)

export default Bogota
